import axios from 'axios';
import { fetchAndActivate, getValue } from 'firebase/remote-config';

export const apiClient = axios.create({
  headers: {
    'Content-Type': 'application/json'
  }
});

export const initialize = (accessToken) => {
  apiClient.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
};

export const clearAccessToken = () => {
  delete apiClient.defaults.headers.common['Authorization'];
};

export const getApiEndpoint = async (config) => {
  const environment = process.env.REACT_APP_NODE_ENV;

  if (environment === 'development') {
    return 'http://localhost:8080/api';
  }

  config.settings = { minimumFetchIntervalMillis: 3600000 };
  await fetchAndActivate(config);
  return getValue(config, `${environment}_api_endpoint`).asString();
};

export const createRequest = async (config, endpoint) => {
  const apiEndpoint = await getApiEndpoint(config);
  return `${apiEndpoint}${endpoint}`;
};

export const queryGet = (config, endpoint) => async () => {
  const url = await createRequest(config, endpoint);
  const response = await apiClient.get(url);
  return response?.data;
};

export const queryPost = (config, endpoint, data) => async () => {
  const url = await createRequest(config, endpoint);
  const response = await apiClient.post(url, data);
  return response?.data;
};

export const queryPut = (config, endpoint, data) => async () => {
  const url = await createRequest(config, endpoint);
  const response = await apiClient.put(url, data);
  return response?.data;
};

export const queryDelete = (config, endpoint, id) => async () => {
  const url = await createRequest(config, `${endpoint}?id=${encodeURIComponent(id)}`);
  const response = await apiClient.delete(url);
  return response?.data;
};
